import { Button } from '@material-ui/core';
import styled from 'styled-components';
import colors from '../../../styles/settings/colors';

export const InfoContainer = styled.div`
  border: solid 1px #000;
  border-radius: 15px;
  margin-top: 10px;
`

export const ConfirmationBox = styled.div`
  max-width: 400px;
  margin: 16px 0;
  width: 100%;

  .confirmation-message {
    display: block;
    font-weight: bold;
    font-family: 'Roboto', sans-serif;
    font-size: 23px;
    margin: 0 0 10px;
  }

  .confirmation-box {
    display: flex;
    flex-flow: row nowrap;
    width: min(300px, 100%) !important;

    input:first-child {
      margin: 0 8px 0 0;
    }

    input {
      background-color: ${colors.sanMarino};
      border-radius: 8px;
      color: #fff;
      font-family: 'Roboto', sans-serif;
      margin: 0 8px;
    }
  }

  button {
    font-family: 'Roboto', sans-serif;
    margin: 8px 0;
    width: 100%;

    &.Mui-disabled {
      background-color: rgb(35 45 100 / 90%) !important;
      cursor: not-allowed !important;
    }
  }
`;


export const RefuseContainer = styled.div`
  margin: 32px 0;

  .MuiTextField-root {
    width: 100%;
  }

  textarea {
    font-family: 'Segoe UI';
  }

  .MuiFormLabel-root {
    color: #000;
    margin-bottom: 12px;
  }

  .MuiFormLabel-root.Mui-focused {
    color: #000 !important;
  }

  .MuiInputBase-root {
    width: 100%;
  }

  .MuiRadio-colorSecondary.Mui-checked {
    color: ${colors.sanMarino};
  }

  .MuiFormHelperText-root {
    font-family: 'Segoe UI';
  }

  .select-paper {
    border: 2px solid ${colors.sanMarino};
    box-sizing: border-box;
    padding: 0 8px;
  }

  button {
    &.Mui-disabled {
      background-color: rgb(35 45 100 / 90%) !important;
      cursor: not-allowed !important;
    }
  }
`;

export const InputLabel = styled.label`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 7px;
`;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  margin: 24px 0 !important;
  min-width: 200px !important;
`;

export const ErrorMessage = styled.span`
  color: ${colors.tundora};
`;
